import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-tailwind/react";
import "./IndividualAcademic.css";

const AcademicList = ({ title, items }) => {
  if (items.length === 0) return null;

  return (
    <div className="academic-list">
      <Typography className="academic-list-title">
        {title}:
      </Typography>
      <ul className="academic-list-items">
        {items.map((item, index) => (
          <li key={index} className="academic-list-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

AcademicList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const IndividualAcademic = ({
  institution,
  degree,
  from,
  to,
  certifications,
  achievements,
  activities,
  hackathons,
  animationDelay = 0,
}) => {
  const delayStyle = {
    animationDelay: `${animationDelay * 0.1}s`,
  };

  return (
    <div className="academic-card" style={delayStyle}>
      <Typography variant="h3" className="academic-institution">
        {institution}
      </Typography>
      <Typography variant="h5" className="academic-degree">
        {degree}
      </Typography>
      <Typography className="academic-duration">
        {from} - {to}
      </Typography>

      <AcademicList items={certifications} title="Notable certifications" />
      <AcademicList items={achievements} title="Notable achievements" />
      <AcademicList items={activities} title="Academic activities" />
      <AcademicList items={hackathons} title="Hackathons" />
    </div>
  );
};

IndividualAcademic.propTypes = {
  institution: PropTypes.string.isRequired,
  degree: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  certifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  achievements: PropTypes.arrayOf(PropTypes.string).isRequired,
  activities: PropTypes.arrayOf(PropTypes.string).isRequired,
  hackathons: PropTypes.arrayOf(PropTypes.string).isRequired,
  animationDelay: PropTypes.number,
};

export default IndividualAcademic;
